<template>
  <tr class="data-table-body-search">
    <!-- ID -->
    <td class="pa-0">
      <v-text-field
        v-model="searchID"
        :prepend-inner-icon="icons.mdiMagnify"
        persistent-placeholder
        clearable
        placeholder="Ara"
        filled
        class="rounded-0 elevation-0"
        hide-details
      />
    </td>

    <!-- Statu -->
    <td class="pa-0">
      <div class="d-flex">
        <v-select
          v-model="searchStatu"
          :items="statusList"
          :prepend-inner-icon="icons.mdiMagnify"
          persistent-placeholder
          clearable
          placeholder="Ara"
          filled
          class="rounded-0 elevation-0"
          hide-details
        />
      </div>
    </td>

    <!-- Hazırlayan -->
    <td class="pa-0">
      <div class="d-flex">
        <v-text-field
          v-model="searchUser"
          :prepend-inner-icon="icons.mdiMagnify"
          persistent-placeholder
          clearable
          placeholder="Ara"
          filled
          class="rounded-0 elevation-0"
          hide-details
        />
      </div>
    </td>

    <!-- Form Tarihi -->
    <td class="pa-0">
      <div class="d-flex">
        <v-menu
          v-model="formDateMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="searchFormDate"
              :prepend-inner-icon="icons.mdiMagnify"
              persistent-placeholder
              clearable
              placeholder="Ara"
              filled
              class="rounded-0 elevation-0"
              hide-details
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="searchFormDate"
            @input="formDateMenu = false"
            :max="new Date().toISOString().split('T')[0]"
            no-title
          >
          </v-date-picker>
        </v-menu>
      </div>
    </td>

    <!-- Boş -->
    <td
      class="pa-0"
      v-for="item in emptySearchCount"
      :key="`emptySearch-${item}`"
    >
      <v-text-field
        filled
        disabled
        class="rounded-0 elevation-0"
        hide-details
      />
    </td>
  </tr>
</template>

<script>
import { mdiMagnify } from "@mdi/js";

export default {
  name: "TableSearch",
  props: {
    statusList: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    emptySearchCount: {
      type: Number,
      default: 4,
    },
  },
  data() {
    return {
      searchID: "",
      searchStatu: "",
      searchUser: "",
      searchFormDate: "",
      formDateMenu: false,
      icons: {
        mdiMagnify,
      },
    };
  },
  created() {
    // Başlangıç değerlerini prop'lardan alıyoruz
    if (this.value) {
      this.searchID = this.value.id || "";
      this.searchStatu = this.value.statu || "";
      this.searchUser = this.value.user || "";
      this.searchFormDate = this.value.formDate || "";
    }
  },
  watch: {
    // Değişiklikleri izleyip emit ediyoruz
    searchID(val) {
      this.emitChanges();
    },
    searchStatu(val) {
      this.emitChanges();
    },
    searchUser(val) {
      this.emitChanges();
    },
    searchFormDate(val) {
      this.emitChanges();
    },
    // Prop değişikliklerini izliyoruz
    value: {
      handler(val) {
        if (val) {
          this.searchID = val.id || this.searchID;
          this.searchStatu = val.statu || this.searchStatu;
          this.searchUser = val.user || this.searchUser;
          this.searchFormDate = val.formDate || this.searchFormDate;
        }
      },
      deep: true,
    },
  },
  methods: {
    emitChanges() {
      this.$emit("input", {
        id: this.searchID,
        statu: this.searchStatu,
        user: this.searchUser,
        formDate: this.searchFormDate,
      });
    },
    clear() {
      this.searchID = "";
      this.searchStatu = "";
      this.searchUser = "";
      this.searchFormDate = "";
      this.emitChanges();
    },
  },
};
</script>
